module.exports = __webpack_public_path__ + "img/wp-new-habit-card14.876c2065.jpg";